import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, ButtonGroup } from 'react-bootstrap'
import { browserHistory } from 'react-router'

import AssmanButton from '../../utils/assmanbutton';

import EmailInvoice from '../emailinvoice'

@observer(['globals', 'companies', 'contacts', 'invoices', 'quickbooks'])
export default class Actions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showEmailInvoiceModal: false
    };
  }

  setLoadableState(loadableState) {
    this.props.setLoadableState(loadableState)
  }

  onEmailButtonClick(row) {
    this.setState({
      showEmailInvoiceModal: true
    });
  }

  onEmailModalClose() {
    this.setState({
      showEmailInvoiceModal: false,
    })
  }

  deleteInvoice(id) {
    this.setLoadableState(true)
    if (confirm('Are you sure you want to delete this invoice?  This action cannot be undone!')) {
      this.props.invoices.deleteInvoice(id, () => { 
        this.props.reload(() => {
          alert('Invoice successfully deleted.')
          this.setLoadableState(false)
        }) 
      })
    }
  }

  uploadInvoiceToQB(row) {
    let isUpdate = row.qbOrderNumber != null;
    let confirmMsg = isUpdate 
      ? 'Are you sure you want to sync this invoice to QuickBooks? This action cannot be undone!'
      : 'Are you sure you want upload this invoice to QuickBooks? This action cannot be undone!';

    if (confirm(confirmMsg)) {
      this.setState({
        loadableState: true
      })

      this.props.invoices.loadInvoice(row.id, (invoice) => {
        let promises = []

        let p1 = new Promise((resolve, reject) => {
          this.props.companies.loadCompanyDetails({ id: invoice.companyId }, (data) => {
            resolve(data)
          })
        })

        let p2 = new Promise((resolve, reject) => {
          this.props.invoices.loadInvoiceHardware(row.id, invoice.qbItemList, (data) => {
            resolve(data)
          })
        })

        promises.push(p1)
        promises.push(p2)

        Promise.all(promises).then((results) => {
          const company = results[0];
          const hardware = results[1];

          let today = new Date()

          let invoiceInfo = {
            invoiceId: this.props.row.id,
            companyId: company.id,
            qbCustomerId: company.qbCustomerId,
            qbOrderNumber: this.props.row.qbOrderNumber,
            txnDate: ((today.getUTCMonth() + 1) + '-' + today.getUTCDate() + '-' + today.getUTCFullYear()),
            note: invoice.note,
            paymentTermId: invoice.paymentTermId,
            taxRateId: invoice.taxRateId,
            billingCompany: invoice.companyName,
            billingName: invoice.billingAddressName,
            billingAddress: invoice.billingAddressAddress,
            billingCity: invoice.billingAddressCity,
            billingState: invoice.billingAddressState,
            billingZipCode: invoice.billingAddressZipCode,
            shippingName: invoice.shippingAddressName,
            shippingAddress: invoice.shippingAddressAddress,
            shippingCity: invoice.shippingAddressCity,
            shippingState: invoice.shippingAddressState,
            shippingZipCode: invoice.shippingAddressZipCode,
            shippingCost: invoice.shippingCost,
            email: company.contactEmail,
            hardwareList: JSON.stringify(hardware).replace(/"/g, '\\"'),
            accessoryList: "[]",
            featureList: "[]"
          }

          if (isUpdate) {
            this.props.quickbooks.quickbooksUpdateInvoice(invoiceInfo, (data) => {
              if (data.quickbooksUpdateInvoice && data.quickbooksUpdateInvoice.statusCode == 200) {
                alert('Invoice synced to QuickBooks.')
                this.props.invoices.loadInvoices()
                this.setState({
                  loadableState: false
                })
              } else {
                let msg = data.quickbooksUpdateInvoice ? data.quickbooksUpdateInvoice.data.message : 'Unknown error occurred during sync.';
                alert(msg)
                this.setState({
                  loadableState: false
                })
              }
            })
          } else {
            this.props.quickbooks.quickbooksCreateInvoice(invoiceInfo, (data) => {
              if (data.quickbooksCreateInvoice && data.quickbooksCreateInvoice.statusCode == 200) {
                alert('Invoice uploaded to QuickBooks.')
                this.props.invoices.loadInvoices()
                this.setState({
                  loadableState: false
                })
              } else {
                let msg = data.quickbooksCreateInvoice ? data.quickbooksCreateInvoice.data.message : 'Unknown error occurred during upload.';
                alert(msg)
                this.setState({
                  loadableState: false
                })
              }
            })
          }
        })
      })
    }
  }  

  render() {
    let isAdmin = localStorage.getItem('userAccessLevel') == 15;

    let editInvoiceButton = <Button bsSize="small" bsStyle="info" disabled><i className="fa fa-pencil" aria-hidden="true"></i> Edit </Button>
    let emailInvoiceButton = <Button bsSize="small" bsStyle="warning" disabled><i className="fa fa-envelope" aria-hidden="true"></i> Email </Button>
    let uploadInvoiceButton = <Button bsSize="small" bsStyle="primary" disabled><i className="fa fa-arrow-circle-up" aria-hidden="true"></i> Upload </Button>
    let deleteInvoiceButton = <Button bsSize="small" bsStyle="danger" disabled><i className="fa fa-trash-o" aria-hidden="true"></i> Delete </Button>

    if (this.props.row.qbOrderNumber == null || isAdmin) {
      editInvoiceButton = <Button bsSize="small" bsStyle="info" onClick={() => { browserHistory.push('/company/editinvoice/' + this.props.row.companyId + '/' + this.props.row.id) }}><i className="fa fa-pencil" aria-hidden="true"></i> Edit </Button>
      emailInvoiceButton = <Button bsSize="small" bsStyle="warning" onClick={() => { this.onEmailButtonClick(this.props.row) }}><i className="fa fa-envelope" aria-hidden="true"></i> Email </Button>
      
      if (this.props.row.qbOrderNumber == null) {
        uploadInvoiceButton = <Button bsSize="small" bsStyle="primary" onClick={() => {this.uploadInvoiceToQB(this.props.row)}}><i className="fa fa-arrow-circle-up" aria-hidden="true"></i> Upload </Button>
      } else {
        uploadInvoiceButton = <Button bsSize="small" bsStyle="primary" onClick={() => {this.uploadInvoiceToQB(this.props.row)}}><i className="fa fa-refresh" aria-hidden="true"></i> Sync </Button>
      }
      
      deleteInvoiceButton = <Button bsSize="small" bsStyle="danger" onClick={() => { this.deleteInvoice(this.props.row.id) }}><i className="fa fa-trash-o" aria-hidden="true"></i> Delete </Button>
    }

    return (
      <div>
        <ButtonGroup>
          <Button bsSize="small" bsStyle="success" onClick={() => { browserHistory.push('/invoice/' + this.props.row.id) }}><i className="fa fa-folder" aria-hidden="true"></i> View </Button>
          <AssmanButton companyId={this.props.row.companyId} onComplete={() => {this.props.invoices.loadUnpaidInvoices()}} />
          { editInvoiceButton }
          { emailInvoiceButton }
          { uploadInvoiceButton }
          { deleteInvoiceButton }
        </ButtonGroup>
        { 
          this.state.showEmailInvoiceModal
          ? <EmailInvoice open={true} data={this.props.row} onClose={this.onEmailModalClose.bind(this)} />
          : ''
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invoices/actions.js